import classNames from 'classnames';

import { CloseBoldV2Icon, ExclamationTriangleIcon } from '../../icons';

import styles from './_index.module.scss';

export interface PillV2Props extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'value'> {
  buttonRef?: React.Ref<HTMLButtonElement>;
  'data-testid'?: string;
  icon?: React.ReactNode;
  isActive?: boolean;
  isBold?: boolean;
  isCompleted?: boolean;
  isDisabled?: boolean;
  isError?: boolean;
  isModified?: boolean;
  isRequired?: boolean;
  onClose?: () => void;
  value?: React.ReactNode;
}

const PillV2 = ({
  buttonRef,
  className,
  'data-testid': dataTestId = 'pill',
  icon,
  isActive,
  isBold = false,
  isCompleted,
  isDisabled,
  isError,
  isModified,
  isRequired,
  onClick = () => {},
  onClose,
  value,
  ...props
}: PillV2Props) => {
  const handleOnClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClose) {
      event.stopPropagation();
      onClose();
    }
  };
  const otherClassNames = {
    [styles['is-active']]: isActive && !isDisabled && !isCompleted,
    [styles['is-completed']]: isCompleted,
    [styles['is-disabled']]: isDisabled && !isRequired && !isCompleted,
    [styles['is-error']]: isError,
    [styles['is-modified']]: isModified && !isDisabled && !isCompleted,
  };

  return (
    <button
      aria-label="pill"
      className={classNames(styles['pill'], className, otherClassNames)}
      data-testid={dataTestId}
      onClick={isCompleted || isDisabled ? () => {} : onClick}
      ref={buttonRef}
      {...props}
    >
      {isError && (
        <span className={styles['pill-icon']}>
          <ExclamationTriangleIcon data-testid="error-icon" />
        </span>
      )}
      {!isError && icon && <span className={styles['pill-icon']}>{icon}</span>}
      {value && (isBold ? <strong>{value}</strong> : value)}
      {isModified && !isDisabled && !isCompleted && (
        <CloseBoldV2Icon
          className={styles['pill-close-icon']}
          data-testid="close-bold-icon"
          // @ts-ignore - onClick on an svg element, should be moved
          onClick={handleOnClose}
        />
      )}
      {isRequired && !isModified && !isCompleted && (
        <span className={styles['pill-required-icon']}>*</span>
      )}
    </button>
  );
};

export default PillV2;
